import React, { useEffect, useState, useContext } from 'react';
import { AccessibilityContext } from 'contexts/AccessibilityContext';
import styles from './Home.module.css';
import UpcomingSpectaclesBlock from 'components/home/UpcomingSpectaclesBlock';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { Helmet } from 'react-helmet';
import { getFeaturedSpectacle, getUpcomingSpectacles, getAllSpectaleSpectacle } from 'services/api';
import SliderSpectacles from 'components/home/SliderSpectacles';
import PharosAsideCard from 'components/home/PharosAsideCard';
import Spinner from 'components/common/Spinner';

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [spectacleFeatured, setSpectacleFeatured] = useState(null);
  const [spectacles, setSpectacles] = useState([]);
  const [concertFeatured, setConcertsFeatured] = useState(null);
  const [concerts, setConcerts] = useState([]);
  const [allSpectacles, setAllSpectacles] = useState([]);

  const { accessibilityOptions, getAccessibilityVariant } = useContext(AccessibilityContext);

  useEffect(() => {
    async function fetchSpectacles() {
      try {
        //AllSpectacles pour les slider
        const allSpectaclesTemp = await getAllSpectaleSpectacle('spectacle');
        setAllSpectacles(allSpectaclesTemp);

        //Spectacles
        const featured = await getFeaturedSpectacle('spectacle');
        const upcoming = await getUpcomingSpectacles('spectacle');
        const filtered = featured
          ? upcoming.filter(s => s.id !== featured.id)
          : upcoming;
        setSpectacleFeatured(featured);
        setSpectacles(filtered);

        //Concerts
        const featured2 = await getFeaturedSpectacle('concert');
        const upcoming2 = await getUpcomingSpectacles('concert');
        const filtered2 = featured2
          ? upcoming2.filter(s => s.id !== featured2.id)
          : upcoming2;
        setConcertsFeatured(featured2);
        console.log('🎯 filtered2 à passer :', filtered2);
        setConcerts(filtered2);
      } catch (err) {
        console.error('Erreur lors du chargement des spectacles :', err);
      } finally {
        setLoading(false);
      }
    }

    fetchSpectacles();
  }, []);

  if (loading) return <div className="page-content section-no-padding">
    <section className={`global-section global-section-title ${styles.section}`} style={{ minHeight: '100vh', paddingTop: 200 }}>
      <Spinner />
    </section>
  </div>;
  //if (!spectacleFeatured) return <div>Spectacle en avant non trouvé.</div>;
  console.log('🎯 concerts à passer :', concerts);

  return (
    <>
      <Helmet>
        <title>Le Pharos - Billetterie officielle</title>
        <meta
          name="description"
          content=""
        />
        <link rel="canonical" href="https://www.arras.fr" />
      </Helmet>

      <main className="homePage" aria-label="Page d'accueil de la ville d'Arras">
        <div className="page-content">

          <h1 className="sr-only">Le Pharos - Billetterie officielle</h1>

          {allSpectacles.length > 0 && (
            <section className={`global-section ${styles.globalSectionHomeSlider}`}>
              <div className={`global-container-slide`}>
                <section className={styles.sliderZone}>
                  <div className={styles.sliderWithAside}>
                    <SliderSpectacles allSpectacles={allSpectacles} />
                    <PharosAsideCard />
                  </div>
                </section>
              </div>
            </section>
          )}
          {(spectacles.length > 0 || spectacleFeatured) && (
            <UpcomingSpectaclesBlock
              type="spectacle"
              spectacleFeatured={spectacleFeatured}
              spectacles={spectacles}
            />
          )}
          {(concerts.length > 0 || concertFeatured) && (
            <UpcomingSpectaclesBlock
              type="concert"
              spectacleFeatured={concertFeatured}
              spectacles={concerts}
            />
          )}
        </div>
      </main>
    </>
  );
};

export default Home;
